export class ContentSize {
    constructor(public height: number, public width: number, public top: number, public left: number, public element?: any) {

    }
}
